import { Col, Row } from "react-bootstrap";
import { ActionsActivityList } from "./ActionsActivityList";
import { ActionsList } from "./ActionsList";

export const ActionsPage: React.FC = () => (
    <Col className="d-flex flex-column gap-4 p-0">
        <Row>
            <Col sm={12} md={8}>
                <ActionsList />
            </Col>
            <Col md={4} className="d-none d-md-block">
                <ActionsActivityList />
            </Col>
        </Row>
    </Col>
);
